// extracted by mini-css-extract-plugin
export default {"share-container":"socialComponent_share-container__Yp0sA","footer-icon-wrapper":"socialComponent_footer-icon-wrapper__QVP-D"};